import Icon from 'atoms/icons/icon';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import { checkOrderStatus } from 'pages/home/sagaActions';
import { getStatusID } from 'pages/home/selectors';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './orderStatus.scss';

const CreateOrderStatus = () => {
	const statusID: number = useSelector((state) => getStatusID(state));
	const dispatch = useDispatch();
	const [showStatus, setShowStatus] = useState(false);

	useEffect(() => {
		if (!statusID) return;

		const timer = setTimeout(() => {
			setShowStatus(true);
			dispatch(checkOrderStatus({ statusID }));
		}, 4000);

		return () => clearTimeout(timer);
	}, [statusID, dispatch]);

	if (!statusID || !showStatus) return null;

	return (
		<div className="order-status">
			<Stack align="center" gutter="small">
				<StackItem>
					<Icon faAlias="faInfoCircle" size="small" />
				</StackItem>
				<StackItem isStretch align="center" position="center">
					We are currently processing your orders and will notify you once they are complete
				</StackItem>
			</Stack>
		</div>
	);
};

export default CreateOrderStatus;
